export enum ApplicantTagEnum {
  YOU = 'primary',
  SPOUSE = 'spouse',
  CHILD = 'dependent',
}
